export default __webpack_public_path__ + "static/media/ferramenta-baixar-videos-img4.37ed5f91.jpeg";